// extracted by mini-css-extract-plugin
module.exports = {"WebGL":"WebGL_WebGL__5TVrc","active":"WebGL_active___BUre"};